<div class="vh-100 w-100">
  <div class="add-card-head d-flex align-items-center justify-content-between hw-65 w-100 p-2 px-4 border-bottom">
    <img src="assets/images/icons/FM-logo-green.svg" alt="Finance Mutual">
    <div class="d-flex">
      <p class="m-0 fs-14 fw-500 grey-65 me-3">
        <img src="assets/images/icons/phone-icon.png" class="" alt="">
        +1 (888) 927-6680
      </p>
      <p class="m-0 fs-14 fw-500 grey-65">
        <img src="assets/images/icons/mail.png" class="" alt="">
        {{'support@financemutualapp.com'}}
      </p>
    </div>
  </div>
  @if (!cardAdded()) {
    <div class="add-card-body d-flex align-items-center justify-content-center">
      @if (!card_already_added() && !loadingBusinessDetails()) {
        <div class="w-100 mxw-650 text-center">
          <h4>
            <p class="fs-14 fw-400 m-0 mb-3" style="color:rgba(187, 187, 187, 1)">
              Hello {{ businessDetails().doctor_name || 'Business' }},
            </p>
            <h4 class="fs-32 fw-800 text-white mb-5">
              Add Your Card to Continue with br
              Secure and Seamless Payments
              <!-- Your Financing Is Activated. <br>
              Add Your Card to Continue -->
            </h4>
            <div class="orange-grd rasius-24 p-2">
              <div class="p-4 py-5 bg-white radius-16">
                <img src="assets/images/icons/add-card.png" alt="">
                <h4 class="fs-20 fw-800 black-40 mb-3">
                  Add your card details using the button below to continue smoothly without any delays.
                </h4>
                <button class="btn btn-secondary fs-16 fw-700 black-40 mb-3" (click)="openAddCardForm()" [disabled]="creatingIntent()">
                  Add Credit/Debit Card
                </button>
                <p class="fs-14 fw-600 grey-70 fst-italic">
                  Your payment details are secured with <br> advanced encryption and SSL protection.
                </p>
              </div>
            </div>
          </h4>
        </div>
      }
      @if (card_already_added() && !loadingBusinessDetails()) {
        <div class="w-100 mxw-650 text-center">
          <div class="orange-grd rasius-24 p-2">
            <div class="p-4 py-5 bg-white radius-16">
              <p class="fs-14 fw-400 m-0 mb-3">
                Hello {{ businessDetails().doctor_name || 'Business' }},
              </p>
              <h4 class="fs-32 fw-800 mb-2">
                Your Card is Already Added. <br>
              </h4>
              <p class="fs-20 fw-600 grey-70">
                Please Login to Your Business Panel .
              </p>
              <button class="btn btn-secondary fs-16 fw-700 black-40 mb-3" (click)="goToLogin()">
                Login To Business Panel
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (cardAdded()) {
    <div class="success-body d-flex align-items-center justify-content-center">
      <div class="text-center success-wrap">
        <img src="assets/images/icons/greenTick.svg" alt="Success" class="success-icon">
        <h3 class="fs-42 fw-800 mb-3 black-40">Success!</h3>
        <p class="fs-20 fw-600 black-40 mb-4">Your Card has been Added Successfully!</p>
        <button class="btn btn-secondary fs-16 fw-700 black-40 px-4" (click)="goToLogin()">Login To Business Panel</button>
      </div>
    </div>
  }
  <div class="add-card-footer d-flex align-items-center justify-content-between  hw-65 w-100 p-2 px-4 border-top">
    <p class="fs-12 fw-500 grey-65 m-0">Copyright {{ currentYear }} Finance Mutual. All Rights Reserved.</p>
    <p class="d-flex align-items-center gap-1 fs-12 fw-500 grey-65 m-0">
      Powered by
      <img src="assets/images/icons/logo-circle-26.png" class="hw-20 mx-1" alt="Finance Mutual">
      FinanceMutual<sup>TM</sup>
    </p>
  </div>
</div>
